import { Component, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ColumnMode } from '@swimlane/ngx-datatable';
import { CreateDeviceDialogComponent } from 'app/dialogs/create-device-dialog/create-device-dialog.component';
import { UpdateDeviceDialogComponent } from 'app/dialogs/update-device-dialog/update-device-dialog.component';
import { AuthService } from 'app/services/auth.service';
import { DeviceService } from 'app/services/models/device.service';
import { BlockUI, NgBlockUI } from 'ng-block-ui';

@Component({
  selector: 'app-company-detail-device-list',
  templateUrl: './company-detail-device-list.component.html',
  styleUrls: ['./company-detail-device-list.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class CompanyDetailDeviceListComponent implements OnInit {
  @ViewChild('tableRowDetails') tableRowDetails: any;

  @BlockUI('section-block') blockUI: NgBlockUI;
  companyId = null;
  rows: any;
  public pageBasic = 1;
  public selectedSize = 5;
  public basicSelectedOption: number = 5;
  totalCount: Number = 0;
  public ColumnMode = ColumnMode;


  deviceMovements: any[] = [];

  constructor(
    private deviceSerivce: DeviceService,
    private activatedRouter: ActivatedRoute,
    private modalService: NgbModal,
    public authService: AuthService) { }

  async ngOnInit() {
    this.activatedRouter.params.subscribe(params => {
      this.companyId = params['id'];
    })

    this.deviceSerivce.event$.subscribe(async result => {
      await this.getAllCompanyDevices(this.pageBasic - 1, this.selectedSize, this.companyId);
    });

    await this.getAllCompanyDevices(this.pageBasic - 1, this.selectedSize, this.companyId);

  }

  async getAllCompanyDevices(page, size, companyId) {
    this.blockUI.start()
    try {
      const data = await this.deviceSerivce.getAllCompanyDevices(page, size, '', companyId);
      this.rows = data.devices;
      console.log(data);
      this.totalCount = data.totalCount;
    } catch (error) {
    }
    this.blockUI.stop()
  }

  async onPageChange(pageNumber: number) {
    await this.getAllCompanyDevices(this.pageBasic - 1, this.selectedSize, this.companyId);
  }
  async onOptionChange() {

    this.selectedSize = Number(this.basicSelectedOption)
    await this.getAllCompanyDevices(this.pageBasic - 1, this.selectedSize, this.companyId);
  }

  createDevice(companyId) {
    const modal = this.modalService.open(CreateDeviceDialogComponent, {
      size: 'lg',
      windowClass: 'modal modal-success'
    });
    modal.componentInstance.data = {
      id: null,
      companyId: companyId,
      isReferenceDevice: companyId == 1
    }
  }

  updateDevice(id, companyId, event) {
    event.stopPropagation();
    const modal = this.modalService.open(UpdateDeviceDialogComponent, {
      size: 'lg',
      windowClass: 'modal modal-success'
    });
    modal.componentInstance.data = {
      id: id,
      companyId: companyId,
      isReferenceDevice: companyId == 1
    }
  }

  async getRowHeight() {
    return await (this.deviceMovements?.length ?? 1) * 25;
  }
}